<template>
  <div>
    <v-layout v-if="sectors.length>0" pt-3 wrap>
      <v-flex xs12 text-center>
        <span
          style="
            padding-left: 50px;
            font-family: poppinssemibold;
            color: #e7ab5f;
            font-size: 38px;
            leetter-spacing: 2px;
          "
        >
          BUSINESS SECTORS
        </span>
      </v-flex>
    </v-layout>
    <v-card tile flat>
      <v-layout wrap>
        <v-flex lg12>
          <v-layout wrap>
            <template v-for="(item, i) in sectors">
              <v-flex pa-6 :key="i" md6 xs12 lg3>
                <v-hover v-slot:default="{ hover }" open-delay="200">
                  <v-card
                    style="cursor: pointer"
                    :elevation="hover ? 16 : 6"
                  v-if="item.image"
                  >
                    <v-img
                        
                      alt="Image couldnt load"
                      :src="baseURL+item.image"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="150px"
                    >
                      <v-layout wrap fill-height>
                        <v-flex class="overlayShade" text-center align-self-end xs12>
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 16px;
                              color: #ffffff;
                              letter-spacing: 1px;
                            "
                            >{{ item.name }}</span
                          >
                        </v-flex>
                      </v-layout>
                       <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#FF2323"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                    </v-img>
                  </v-card>
                </v-hover>
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      sectors:[],
    };
  },
  mounted: function () {
    this.getSectors();
  },
  methods: {
    getSectors() {
      axios({
        method: "GET",
        url: "/homepage/businessSector/list",
      })
        .then((response) => {
          if(response.data.status)
          this.sectors = response.data.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.overlayShade {
  background-color: rgba(0, 0, 0, 0.7);
}
</style>